import { render, staticRenderFns } from "./videoImage.vue?vue&type=template&id=790b05e1&scoped=true"
import script from "./videoImage.vue?vue&type=script&lang=js"
export * from "./videoImage.vue?vue&type=script&lang=js"
import style0 from "./videoImage.vue?vue&type=style&index=0&id=790b05e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790b05e1",
  null
  
)

export default component.exports